import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import Menu from "./components/Menu/Menu";
import InputText from "./components/Input/InputText";
import LoadingIcon from "./components/LoadingIcon/LoadingIcon";
import LoadingScreen from "./components/LoadingScreen/LoadingScreen";
import RegisterModal from "./components/RegisterModal/RegisterModal";
import ForgotPasswordModal from "./components/ForgotPasswordModal/ForgotPasswordModal";
import KitResults from './components/KitResults/KitResults'
import KitRisks from './components/KitRisks/KitRisks'
import KitPlans from './components/KitPlans/KitPlans'
import KitTips from './components/KitTips/KitTips'

const GlobalComponents = {
  install(Vue) {
    Vue.component("header-div", Header);
    Vue.component("footer-div", Footer);
    Vue.component("side-menu", Menu);
    Vue.component("input-text", InputText);
    Vue.component("loading", LoadingIcon);
    Vue.component("loading-screen", LoadingScreen);
    Vue.component("register-modal", RegisterModal);
    Vue.component("forgot-password-modal", ForgotPasswordModal);
    Vue.component("kit-results", KitResults);
    Vue.component("kit-risks", KitRisks);
    Vue.component("kit-plans", KitPlans);
    Vue.component("kit-tips", KitTips);
  }
};

export default GlobalComponents;



// WEBPACK FOOTER //
// ./src/globalComponents.js